import { useCallback, useMemo } from "react";

import type { PermissionAction } from "@lib/permissionConstants";
import { PERMISSION_ACTION_DISPLAY_NAMES } from "@lib/permissionConstants";

import useI18nNamespace from "@services/useI18nNamespace";

/**
 * Capitalized display strings for permission resource actions.
 */
export const usePermissionActionDisplayString = () => {
  const { t: permissionActionT } = useI18nNamespace("permission-actions");
  const permissionActionNames = useMemo(() => {
    return PERMISSION_ACTION_DISPLAY_NAMES(permissionActionT);
  }, [permissionActionT]);

  return useCallback(
    (permissionAction: PermissionAction) => {
      return permissionActionNames[permissionAction];
    },
    [permissionActionNames]
  );
};
